import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 410,
    minHeight: 240,
    '& div.loading': {
      marginTop: 90
    }
  }
}))

export {
  useStyles
}